const SKILL_ICON_BASE = `${process.env.PUBLIC_URL}/skill-icons`;

export const SKILL_ICONS = {
  brandStrategy: `${SKILL_ICON_BASE}/brand-strategy.png`,
  artDirection: `${SKILL_ICON_BASE}/art-direction.png`,
  campaignDevelopment: `${SKILL_ICON_BASE}/campaign-development.png`,
  typography: `${SKILL_ICON_BASE}/typography.png`,
  storytelling: `${SKILL_ICON_BASE}/storytelling.png`,
  motionDesign: `${SKILL_ICON_BASE}/motion-design.png`,
  clientPresentation: `${SKILL_ICON_BASE}/client-presentation.png`,
  teamLeadership: `${SKILL_ICON_BASE}/team-leadership.png`,
};
